import { render, staticRenderFns } from "./CompanyLoyaltyConfig.vue?vue&type=template&id=e806cfdc&scoped=true"
import script from "./CompanyLoyaltyConfig.vue?vue&type=script&lang=js"
export * from "./CompanyLoyaltyConfig.vue?vue&type=script&lang=js"
import style0 from "./CompanyLoyaltyConfig.vue?vue&type=style&index=0&id=e806cfdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e806cfdc",
  null
  
)

export default component.exports